import SantaShopViewer from '../../components/santaShop/SantaShopViewer';
export default function SantaShopViewerPage () {

    return (
        <>
            <SantaShopViewer />
        </>
    )
}